import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import './text.css';

const Text = ({ block }) => {
  const text = block.getIn(['fields', 'text', 'value']);

  return (
    <div className="block-text" dangerouslySetInnerHTML={{ __html: text }} />
  );
};

Text.propTypes = {
  block: PropTypes.instanceOf(Map).isRequired,
};

export default Text;



// WEBPACK FOOTER //
// ./src/components/blocks/text/index.jsx